import React from 'react';
import { Link } from '../router';
import { useAuth } from '../auth';
import { SITE } from '../config';
import Icon from '../components/Icon';
import { SiteLayout } from '../components/Site';

export default function ExtensionPage() {
  const { config, me } = useAuth();
  return (
    <SiteLayout>
      <div className="doc">
        <span className="pill"><Icon name="puzzle" size={14} /> Chrome extension{config!.extensionVersion && ` · v${config!.extensionVersion}`}</span>
        <h1 style={{ marginTop: 16 }}>Install the CodeReviser extension</h1>
        <p className="updated">Works in Chrome, Edge, Brave, Arc and other Chromium browsers.</p>

        <div className="hero-ctas" style={{ marginTop: 0 }}>
          {SITE.chromeStoreUrl && (
            <a href={SITE.chromeStoreUrl} className="btn btn-primary btn-lg" target="_blank" rel="noopener noreferrer">
              <Icon name="puzzle" size={16} /> Add to Chrome
            </a>
          )}
          <a href={SITE.extensionZip} className={`btn btn-lg ${SITE.chromeStoreUrl ? 'btn-secondary' : 'btn-primary'}`} download>
            <Icon name="download" size={16} /> Download .zip
          </a>
          {!me?.authenticated && <Link to="/signup?next=/extension" className="btn btn-ghost btn-lg">Create a free account first</Link>}
        </div>

        <h2>Install from the zip</h2>
        <ol className="ext-steps" style={{ marginTop: 16 }}>
          <li><span><strong>Unzip</strong> the download. You'll get a folder called <code>codereviser</code>.</span></li>
          <li><span>Open <code>chrome://extensions</code> and turn on <strong>Developer mode</strong> (top right).</span></li>
          <li><span>Click <strong>Load unpacked</strong> and select the <code>codereviser</code> folder.</span></li>
          <li><span>Pin CodeReviser to the toolbar, open it, and click <strong>Sign in</strong>.</span></li>
        </ol>

        <h2>Using it</h2>
        <ul>
          <li>Solve a problem on LeetCode. When the submission is <strong>Accepted</strong>, a panel asks for your approach.</li>
          <li>Or click the floating save button on any problem page to save it manually.</li>
          <li>The popup shows what's due. Do full timed, AI-graded sessions in the <Link to="/app">dashboard</Link>.</li>
        </ul>

        <h2>Updating</h2>
        <p>
          Download the latest zip, replace the old folder with the new one, then click the reload icon on the
          CodeReviser card in <code>chrome://extensions</code>. Your problems live in your account, so nothing is lost.
        </p>
      </div>
    </SiteLayout>
  );
}

export function ExtensionConnected() {
  return (
    <div className="auth-page">
      <div className="card auth-card" style={{ textAlign: 'center' }}>
        <div className="empty-icon"><Icon name="check" size={22} /></div>
        <h1 className="auth-title">You're signed in</h1>
        <p className="auth-sub">
          The extension is now connected to your account. Close this tab and head back to LeetCode. Accepted
          problems will save straight to your dashboard.
        </p>
        <Link to="/app" className="btn btn-primary btn-block">Open dashboard</Link>
      </div>
    </div>
  );
}
